export default {
  tab: '候选人申请',
  title: {
    list: '求职者列表',
    source: '来源',
    applicationDetail: '申请信息',
    profileDetail: '简历信息',
    assessmentFit: '测评',
    problemSolvingFit: '问题解决能力测评',
    hiringManage: '选择招聘经理',
    addComments: '添加评论',
    sendInvitation: '发送邀请',
    selectInterviewQuestionnaire: '选择面试问卷',
    selectQuestionnaire: '选择问卷',
    interviewerAndTimeAndLocation: '选择面试官/时间/地点',
    interviewTimeAndLocation: '面试时间地点',
    copyCandidate: '复制求职者',
    copyCandidates: '复制求职者',
    tag: '标签',
    tip: '提示',
    exportCandidate: '导出求职者全部信息',
    potential: '潜在候选人列表',
    addTag: '添加标签',
    smartTags: '智能标签',
    employer: '雇主',
    jobTitle: '职位',
    industry: '行业',
    skill: '技能',
    education: '教育',
    crmTag: '标签',
    crmCampaign: '活动',
    candidateBehavior: '候选人互动',
    candidatePreferences: '候选人偏好',
    otherFactors: '其他',
    candidateType: '候选人类型',
    aiTalentPoolRecommenderSelectJobTitle: '选择职位生成专属推荐',
    aiTalentPoolRecommenderTitle: 'AI 人才库推荐',
    smartTag: '智能标签',
    aiRecommendedList: '人才库推荐列表',
    recommendedInfo: 'AI 人才库推荐',
    selectHiringManager: '请选择面试官：',
    selectInterviewTimeRange: '请选择三个时间段，这些时间段将与候选人共享：',
    selectLocation: '请选择面试地点：',
    hiringManager: '面试官：',
    automate: '自动面试安排：',
    interviewType: '面试/测评中心类别',
    groupInterview: '快速小组面试'
  },
  dialogTitle: {
    changeCandidateStatus: '改变 {candidateName} 的求职状态',
    changeMultipleCandidateStatus: '改变求职状态',
    previewInterviewEmailDialogTitle: '面试邮件预览',
    previewInviteRateEmailDialogTitle: '评估邮件预览',
    aiComparisonLoadingTitle: '生成 AI 对比'
  },
  questionnairePreview: {
    questionLabel: '问题 {index}：',
    answerLabel: '答案：',
    interviewer: '面试官',
    selectAll: '全选',
    weighting: '权重 {weight}%',
    questionType: {
      rating: '评分题',
      text: '文本题',
      single: '单选题',
      multiple: '多选题',
      date: '日期题'
    }
  },
  label: {
    name: '名称',
    saveSearch: '保存搜索',
    keywords: '关键字',
    sourceChannel: '渠道',
    referral: '推荐者',
    gender: '性别',
    job: '申请职位',
    candidateStatus: '候选人状态',
    status: '状态',
    tag: '标签',
    candidateType: '候选人类型',
    contactStatus: '联系状态',
    workCompanyName: '雇主',
    workCompanyNameSearch: '雇主搜索',
    lastWorkJobNameSearch: '职位名称搜索',
    lastWorkJobName: '职位名称',
    location: '当前所在地',
    expectedLocation: '期望工作地点',
    graduateYear: '毕业年份',
    maxDegree: '最高学历',
    workYear: '工作年限',
    school: '学校',
    consentStatus: '协议同意情况',
    age: '年龄',
    ageAndGender: '年龄/性别',
    candidateId: '候选人ID',
    employeeId: '员工ID',
    language: '语言',
    appliedDate: '申请日期',
    hiringManages: '填写你想邀请的招聘经理的联系信息：',
    hiringComments: '给求职者添加一些评论，以供招聘经理参考。',
    noOpenQuestion: '该职位目前没有开放性问题，请点击下一步继续。',
    invitation: '查看或自定义邀请，然后发送给招聘经理：',
    confirmInterview: '创建Teams面试，并发送最终邀请邮件给招聘经理和候选人。',
    invitationSubject: '主题',
    interviewQuestionnaire: '确认需要面试官评估的面试表单。',
    ratingQuestionnaire: '确认需要评估的表单。',
    interviewType: {
      title: '面试类型',
      f2fType: '现场面试',
      online: '线上面试',
      telephone: '电话面试',
      teams: 'MS Teams',
      zoom: 'Zoom'
    },
    selectTemplate: '从模板中选择标准',
    createQuestion: '创建新的标准',
    selectInterviewQuestionnaire: '选择面试问卷',
    selectQuestionnaire: '选择问卷',
    addQuestionnaire: '添加问卷',
    select: '选择',
    scale: '分制：',
    noQuestionnaire: '暂无问卷',
    interviewerAndTimeAndLocation: '请选择面试官，时间以及地点',
    interviewTimeAndLocation: '请填写面试时间和地点：',
    selectAll: '选择全部',
    timeZone: '时区：',
    toStatus: '状态',
    changeCandidateStatusCause: '原因',
    changeComment: '评论',
    saveNewSearch: '保存新搜索',
    updateSearch: '更新已存在的搜索',
    weChatChannelName: '微信',
    onboardDate: '预计上岗时间',
    hiredDate: '雇用日期',
    employeeType: '员工类型',
    userEmail: '用户邮箱',
    endEmploymentDate: '雇佣结束日期',
    compensationBasis: '薪酬基数',
    myJob: '我的职位',
    candidateName: '姓名',
    hidedCandidateName: '候选人',
    employee: '员工',
    candidate: '求职者',
    alumni: '前员工',
    alumniNew: '新前员工',
    employeeNew: '新员工',
    candidateNew: '新求职者',
    employeeReferral: '员工分享推荐',
    candidateReferral: '非员工分享推荐',
    employeeSubmitted: '员工提交推荐',
    candidateSubmitted: '非员工提交推荐',
    degree: '学历',
    selectedTag: '{count} 个标签',
    sendToHM: '1. 发送给招聘经理',
    sendToCandidate: '2. 发送给候选人',
    applicant: '人',
    applicants: '人',
    people: '人',
    pleaseStartTyping: '请开始输入',
    total: '总数',
    searchResult: '搜索结果',
    selected: '选中',
    resumeFit: '工作经验匹配度',
    cultureFit: '公司文化匹配度',
    personalityFit: '职业性格匹配度',
    problemSolvingFit: '问题解决能力',
    aiInterviewFit: 'AI 面试',
    major: '专业',
    group: '分组',
    workExperienceYear: '工作年限',
    year: '年',
    month: '个月',
    filter: {
      personalityFit: '职业性格匹配度',
      cultureFit: '公司文化匹配度'
    },
    recruiterQuestionnaire: '招聘人员筛选',
    applicantQuestionnaire: '申请人问卷答复',
    prescreenQuestionnaire: '申请人问卷答复（聊天机器人）',
    consentVersionCode: '版',
    joinedStartTimeJoinedEndTime: '加入日期',
    activeness: '积极性',
    candidateSurveyQuestions: '候选人偏好问卷答复',
    employeeSurveyQuestions: '员工偏好问卷答复',
    company: '公司',
    candidateNPS: '候选人净推荐值',
    problemSolvingFilter: {
      count_null: '问题解决能力评测: No',
      count_1: '问题解决能力评测: BASIC',
      count_2: '问题解决能力评测: CAPABLE',
      count_3: '问题解决能力评测: CAPABLE',
      count_4: '问题解决能力评测: ADVANCED',
      count_5: '问题解决能力评测: ADVANCED'
    },
    emailAddress: '邮箱',
    referralChain: '推荐链',
    baseInfo: '基本信息',
    jobs: '职位',
    referralInfo: '推荐者',
    noEmployee: '非员工',
    referralMobile: '手机账号：',
    referralEmail: '邮箱：',
    referralName: '姓名：',
    referralReason: '推荐原因：',
    new: '未读',
    all: '所有',
    SCREEN: '筛选',
    INTERVIEW: '面试',
    OFFER: 'Offer',
    HIRED: '雇佣',
    leads: '潜在',
    openDays: '开放天数',
    readStatus: '已读/未读',
    applicationStatus: '简历状态',
    candidatePreferenceSurvey: '偏好问卷',
    microsite: '微网站',
    previewCandidateEmail: '发送给候选人',
    previewHmEmail: '发送给招聘经理',
    interviewer: '面试官',
    scheduleType: {
      busy: '忙碌',
      noInfo: '无信息',
      outsideOfWork: '非工作时间',
      selected: '已选择'
    },
    cvOwner: '简历拥有者',
    ungrouped: '未分组',
    hasPhone: '是否有手机号',
    aiAnalysisAction: 'AI 分析',
    currentOnly: '仅最近工作',
    skills: '技能信息',
    education: '教育信息',
    workExperience: '工作经历',
    riskTag: '潜在风险点（BETA）',
    selectedTagCount: '已选择 {count} 个标签',
    stabilityTag: '工作稳定性（BETA）',
    companyLevelTag: '雇主排行榜',
    workPositionTag: '标准化职位名称',
    workIndustryTag: '标准化行业',
    workIndustry: '行业',
    lastWorkIndustry: '最近的行业',
    skillTag: '技能',
    hardSkillTag: '硬技能（BETA）',
    softSkillTag: '软技能（BETA）',
    schoolTier: '学校标签',
    foreignEducationExperience: '海外留学经历',
    crmTag: '标签',
    openedCampaign: '活动打开标签',
    sharedCampaign: '活动分享标签',
    appliedCampaign: '活动申请标签',
    screenedCampaign: '活动筛选标签',
    interviewCampaign: '活动面试标签',
    hiredCampaign: '活动雇用标签',
    expectedSalary: '期望薪资',
    BelongingEntity: '所属公司',
    appliedEntity: '申请所属公司',
    appliedJob: '申请职位',
    aiTalentPoolRecommenderJob: '职位',
    aiTalentPoolRecommenderTip: '根据所选工作，AJINGA 智能体建议采用以下筛查标准。根据需要进行查看和修改，然后单击“推荐”以生成您的结果。AJINGA 智能体将根据您的职位描述的适合程度（A、B或C）推荐合适的候选人。',
    aiTalentPoolRecommenderLocationLabel: '地点',
    aiTalentPoolRecommenderLocationTip: '如果选择多个地点，AJINGA 智能 AI 将考虑至少有一个地点匹配到的候选人。',
    aiTalentPoolRecommenderWorkExperienceLabel: '工作时间（年）',
    aiTalentPoolRecommenderDegreeLabel: '学历',
    aiTalentPoolRecommenderHardSkillLabel: '硬技能',
    aiTalentPoolRecommenderHardSkillTip: '如果选择多种硬技能，AJINGA 智能 AI 将考虑至少有一种硬技能匹配到的候选人。',
    industry: '行业',
    aiTalentRecommendedListTitle: 'AI 人才库推荐',
    aiTaskCreatedTime: '时间',
    aiTaskCreatorName: '招聘人员',
    aiRecommendIsGenerating: 'AI 人才库推荐正在生成中',
    aiComparisonHistoryTitle: 'AI 对比历史',
    aiComparisonCandidates: '求职者',
    aiTaskAction: '操作',
    aiTaskTime: '{weekday}， {year}年{month}{day}',
    aiComparisonRecommendedTitle: '推荐',
    aiComparisonSummaryTitle: '总结',
    confirmCreateJobCriterionTitle: '是否去设置职位准则',
    confirmCreateJobCriterionContent: '当前职位没有可用的准则，是否去设置',
    recommendedStatus: '筛选 AI 人才库推荐列表',
    historySearch: '推荐历史',
    historyIndex: '推荐模型v{index} ({date})',
    aiRecommendedHistoryTitle: 'AI 推荐历史',
    openedTag: '打开职位标签',
    sharedTag: '分享职位标签',
    appliedTag: '申请职位标签',
    noComparisonTip: '简历不完整',
    aiComparisonSummaryTip: 'AJINGA 智能 AI对比表根据您设定的关键标准对选定的候选人进行评估，并在其中识别出最匹配的候选人。这只是一个比较分析，不会评估所有申请人或所有职位要求。该建议仅仅是从所选候选人中推荐合适的候选人，并不一定代表最适合该职位的整体最佳人选。',
    disabledStatus: '{status}（已禁用）',
    myCandidates: '我的候选人',
    aiInterviewScore: 'AI 面试',
    interviewRecommendation: '面试结果',
    noticeRecruiter: '邮件通知',
    showAll: '显示所有：',
    interviewDuration: '时长：',
    hours: '{hour} 小时',
    minutes: '{minute} 分钟',
    single: '单个',
    multiple: '多个',
    individual: '个人',
    groupInterviewType: '群组',
    enableAutomate: '根据面试官忙闲启用自动面试安排',
    enableInterviewGroup: '添加小组面试名称',
    teamsMeeting: '系统将生成一个TEAMS链接',
    zoomMeeting: '系统将生成一个Zoom链接',
    selectTime: '选择时间',
    telephoneTip: '面试官将自行联系候选人',
    metaIndustry: '行业',
    metaJobFunction: '职能',
    talentRecommendation: {
      skills: '技能',
      createdTime: '时间',
      creatorName: '招聘人员',
      serialNumberTitle: '版本',
      serialNumber: '推荐模型v{index} ({date}) - 更多推荐{loadTask}',
      serialNumberBest: '推荐模型v{index} ({date}) - 最佳推荐',
      loadTaskSerialNumberBest: '最佳推荐',
      loadTaskSerialNumber: '更多推荐{loadTask}',
      loadTaskStatus: '状态',
      recentIndustry: '最近的行业',
      jobFunction: '职能',
      seniority: '资历',
      status: {
        MOVED: '已移动到申请列表',
        INVITED: '已邀请申请',
        PENDING: '待筛选',
        UNQUALIFIED: '不合适'
      }
    },
    refreshAllCandidateAIResumeMatch: '刷新 AI 匹配分数',
    refreshAllCandidateAIResumeMatchContent: '当前存在未完成的任务，是否确认重新开始',
    confirmRefreshAllCandidateAIResumeMatchContent: '此操作由于资源消耗较高，每周仅可执行一次。请确认您要刷新所有候选人的 AI 匹配评分。',
    aiSearch: 'AI 搜索',
    useAiSearch: '使用 AI 搜索'
  },
  placeholder: {
    selectJob: '选择职位',
    selectTag: '选择标签',
    hiringEmails: '邮箱地址',
    hiringFirstName: '名',
    hiringLastName: '姓',
    commentsPlaceholder: '请在这输入内容',
    userEmail: '请为候选人创建一个邮箱，仅输入邮箱前缀即可。',
    compensationBasis: '请输入薪酬标准（请注意输入薪资为每小时时薪/人民币）',
    groupKeyWord: '按分组搜索',
    searchQuestionnaire: '搜索',
    selectTimeZone: '选择时区',
    selectDate: '选择日期',
    selectStartTime: '选择开始时间',
    selectEndTime: '选择结束时间',
    selectLocation: '选择地点',
    interviewCriteria: '请输入新的标准',
    keywordsSearch: '关键字搜索',
    candidateNameSearch: '候选人姓名搜索',
    candidateIdSearch: '候选人ID',
    employeeIdSearch: '员工ID',
    exportCandidateAllInfoTip: '请输入分组名搜索',
    onlineInterview: {
      url: '会议URL（必填）',
      meetingId: '会议ID （可选）',
      meetingPassword: '密码 （可选）'
    },
    microsite: '请选择微网站',
    interviewEmailTemplateLanguage: '请选择语言',
    teamsMeetingGenerated: '待生成',
    input: '请输入',
    selectMeetingRoom: '选择会议室',
    inputTelephone: '请输入手机号码',
    aiSearch: '请描述您理想的候选人——包括技能、经验和地点。就像向同事说明岗位一样，直接输入即可。',
    select: '请选择',
    groupInterviewName: '群组名称'
  },
  btn: {
    action: {
      changeStatus: '更改状态',
      copyCandidate: '复制求职者',
      copyCandidates: '复制求职者',
      inviteHMRating: '邀请招聘经理评估',
      inviteInterview: '邀请面试',
      inviteAIInterview: '邀请AI面试',
      inviteAnswerQuestion: '向候选人发送申请问卷',
      inviteOnboarding: '发起入职',
      inviteSatisfactionSurvey: '向候选人发送满意度调查',
      invitePostApplicant: '向候选人发送体验门户',
      talentGroup: '人才库分组',
      group: '分组',
      talentExport: '导出',
      exportAllCandidateInfo: '全部信息',
      addTalentGroup: '添加分组',
      editTalentGroup: '编辑分组',
      contact: '联系',
      inviteAnswerORQuestion: '邀请回答OR问卷',
      addTag: '添加标签',
      inviteValueAndStrengthLabel: '邀请做价值观&优势测评',
      inviteProblemSolveLabel: '邀请做问题解决能力测评',
      addComment: '添加评论',
      inviteAgreeConsent: '发送收集协议同意邮件和短信',
      createAIResumeMatch: '生成 AI 匹配分数',
      candidateAIMatchTable: '查看/编辑 AI 匹配标准',
      refreshAllCandidateAIResumeMatch: '刷新 AI 匹配分数',
      createAIComparison: '生成 AI 对比',
      viewAIComparisonHistory: '查看 AI 对比历史',
      generateAIRecommendation: 'AI 人才库推荐',
      recommendMoreTalent: '生成更多推荐',
      candidateAIComparisonTable: '查看/编辑候选人 AI 对比标准',
      markRecommendedStatusToUnqualified: '标记为不合适',
      markRecommendedStatusToPending: '标记为待筛选',
      viewAIRecommendationHistory: 'AI 推荐历史',
      moveToApplyJob: '移动到申请列表'
    },
    uploadCandidate: {
      single: '添加单个求职者',
      batch: '添加多个求职者（批量）'
    },
    selectAll: '选择全部',
    interviewer: '我是面试官',
    moveForward: '进入下一阶段',
    reject: '拒绝',
    viewLeads: '查看潜在候选人',
    viewCandidate: '查看候选人',
    previewEmail: '预览',
    microsoftGraphTeamsMeeting: '创建 Microsoft Teams 会议',
    clear: '清空',
    viewAITaskDetail: '查看',
    aiTalentPoolRecommenderBtn: '推荐',
    addTag: '点击添加标签',
    talentRecommendation: {
      view: '查看',
      retry: '重试',
      viewCondition: '查看条件',
      reset: '重置',
      regenerate: '重新生成',
      returnAndEdit: '返回',
      inviteApplyJob: '邀请申请工作',
      generateRecommendation: '查看/编辑推荐标准'
    }
  },
  message: {
    endEmploymentDateBeforeHiredDate: '雇佣结束日期不能早于雇用日期',
    compensationBasisPositive: '薪酬基数必须大于 0',
    userEmailInvalid: '邮箱前缀仅允许输入英文字母、数字、点、下划线和连字符，不能包含空格或 @',
    onlySameJobCandidatesCanInvite: '只有同一职位的候选人可以被邀请',
    saveOrUpdate: '另存为新的搜索或更新已存在的搜索',
    addJobRequired: '至少添加一个工作',
    selectAtLeastCandidate: '至少选择一位求职者',
    hmRequired: '至少选择一位招聘经理',
    groupInterviewHmCount: '请至少选择两位招聘经理以创建快速小组面试。',
    groupInterviewNameRequired: '请输入群组名称。',
    groupInterviewQuestionnaireRequired: '请选择问卷以创建快速小组面试。',
    questionInterviewerRequired: '请为每个问题至少分配一位招聘经理。',
    allHmMustBeAssigned: '请确保每位招聘经理至少分配到一个问题。',
    inviteAIInterviewSuccess: '邀请成功',
    inviteAIInterviewResult: '已选择{totalCount}人发送邀请，{successCount}人已邀请成功，{failedCount}人邀请失败，{hasInvitedCount}人已邀请过AI面试',
    inviteAgreeConsent: {
      success: '邮件和短信发送成功',
      fail: '邮件和短信发送失败'
    },
    copyCandidate: {
      success: '复制成功',
      notAllSuccess: '复制完成，{count} 个求职者未能复制成功',
      failed: '复制失败'
    },
    addTag: {
      success: '添加成功',
      failed: '添加失败'
    },
    emailExisted: '输入的邮箱已存在',
    noData: '没有更多的数据了',
    deleteSearchTemplate: '确认删除此保存搜索？',
    deleteSuccess: '删除成功',
    deleteGroupSuccess: '分组删除成功',
    npsHelpTip: {
      count: 'N= 回答总数',
      inviteCount: '{invitationCount} 是发出的邀请数',
      rate: '{rate}% 是回答的转化率'
    },
    ExcelDownloadTip: [
      '谢谢，我们正在处理您的数据以供下载。完成后，我们会通过电子邮件通知您。',
      '请注意，如果您尝试下载大量数据（字段和记录），处理时间可能长达 2 小时。感谢您的耐心等待。',
      '对于大量下载，您也可以联系您的客户成功顾问，以便他们主动监控下载过程，并在出现任何潜在的“脏数据”问题时提供帮助。'
    ].map((item) => `<p style="line-height: 20px">${item}</p>`).join(''),
    inviteORQuestion: '您已选择{inviteCount}人发送邀请，{successCount}人已邀请成功。',
    selectAllCandidateLimit: '此批量操作仅支持选取最多{maxLimit}位候选人，请重新选择候选人。联系你的AJINGA管理员或者客户成功顾问获取更多支持。',
    exportOriginalResumeTaskCreated: '导出任务已创建，完成后我们会通过电子邮件通知您。',
    inviteFinishAssessment: {
      success: '邀请成功',
      noEmailAccount: '该用户没有填写邮箱，我们暂时无法邀请该求职者。短信邀请正在紧张制作中，敬请期待！',
      hasFinished: '该用户已完成测评填写，无需邀请',
      fail: '邀请失败',
      batchInvite: '您已选择{candidateCount}人发送邀请，{successCount}人已邀请成功，{noEmailCount}人没有邮箱地址，{completedCount}人已经完成评测'
    },
    scheduleSearchDayOutLimit: 'Teams 仅支持查询两个月内数据',
    addToGenerateTaskSuccessful: '请稍后，我们正在计算匹配度分数。谢谢！',
    aiComparisonCountError: '选择{min}-{max}位候选人',
    aiComparisonCriterionError: '让我们开始吧！',
    aiComparisonCriterionErrorContent: '点击“生成”按钮建立你的关键对比标准吧！',
    aiComparisonError: '出了一点小问题，看起来就连 AI 都需要休息一小会。请稍后尝试重新生成。',
    moveCandidateToApplication: {
      success: '已更新',
      failed: '服务器错误，请重试'
    },
    confirmDeleteTagTip: '确定要删除这个标签吗？',
    changeStatusResult: {
      consentFailed: '无法更新该候选人的状态，因为该候选人尚未同意隐私政策。',
      sameChangeRecord: '该候选人的状态已设置为此状态。请选择其他状态或关闭窗口。',
      referralError: '由于推荐奖励计划，此职位的状态变更流程逻辑固定。请根据推荐流程逻辑更新下一个状态。',
      success: '状态更新成功。',
      batch: {
        success: '状态更新成功。',
        failed: {
          base: [
            '{success} 位候选人的状态已成功更新。<br/>',
            '{failed} 个错误：<br/>'
          ].join(''),
          join: '，<br/>',
          end: '。',
          consentFailed: '{consentFailed} 位候选人尚未同意隐私政策',
          sameChangeRecord: '{sameChangeRecord} 位候选人当前处于此状态',
          referralError: '{referralError} 位候选人的状态更新失败，因为它不符合已定义的推荐计划状态变更流程逻辑'
        }
      }
    },
    disabledActionCandidate: '您无权管理此列表中的某些候选人。请使用左侧搜索栏中的我的候选人切换按钮来选择我的候选人',
    disabledActionCandidateInJob: '您没有权限管理此职位的候选人。',
    duplicateDateTime: '时间段重复，请重新选择',
    changeDuration: '请更改面试时长',
    selectInterviewTime: '请至少选择一个面试时间',
    maxSelectScheduleCount: '最多只能选择{maxCount}个时间段',
    aiRecommendSuccess: '成功生成了智能 AI 人才库推荐。',
    aiRecommendNoCandidate: '哎呀，看起来没有更多符合此搜索条件的候选人了。请扩大您的搜索条件后重试。',
    recommendedIsEmptyRetryTip: '该推荐条件下没有合适的候选人，请调整推荐标准后重新生成。',
    sameRecommendationConditionTip: '存在相同条件的推荐，您可以选择修改或者查看已存在的推荐',
    copyRecommendedCandidateTitle: '确认移动该候选人到申请列表',
    copyRecommendedCandidateContent: '确认移动{count}个候选人到申请列表？',
    copyOneCandidateRecommendedCandidateContent: '确认移动该候选人到申请列表？',
    talentRecommendConditionGenerateFailed: '智能AI突然开小差了，请重试。',
    updateRecommendedCandidateSuccess: '已更新',
    recommendationLoadTaskRunningTip: '您可以在此处等待结果，也可以关闭此弹出窗口，稍后通过单击求职者列表中的 AI 人才库推荐来查看结果。',
    recommendationLoadTaskRunningStatus: {
      start: 'AJINGA 智能 AI 正在处理您的请求。',
      review: 'AJINGA 智能 AI 正在审查标准…',
      search: 'AJINGA 智能 AI 正在寻找人才库…',
      read: 'AJINGA 智能 AI 正在阅读候选人简历…',
      rankAndSummary: 'AJINGA 智能 AI 正在对候选人进行比较…',
      save: 'AJINGA 智能 AI 正在为您输出候选人名单…'
    },
    refreshAIResumeMatchError: '该操作7天内只能执行一次，请于{day}天后再次尝试。',
    refreshAIResumeMatchSuccess: '计算中…',
    noOriginalResume: '所选数据中未包含原始简历。'
  },
  referralType: {
    ALL_REFERRAL: '被推荐的人',
    EMPLOYEE_SHARED: '员工分享推荐',
    CANDIDATE_SHARED: '非员工分享推荐',
    EMPLOYEE_SUBMITTED: '员工提交推荐',
    CANDIDATE_SUBMITTED: '非员工提交推荐',
    NO_REFERRAL: '非被推荐的人'
  },
  gender: {
    MALE: '男',
    FEMALE: '女',
    NON_BINARY: '非二元',
    PREFER_NOT_TO_DISCLOSE: '不愿透露'
  },
  candidateType: {
    EMPLOYEE: '员工',
    CANDIDATE: '非员工'
  },
  contactStatus: {
    HAS_CONTACTED: '已联系',
    NO_CONTACTED: '未联系'
  },
  consentStatus: {
    AGREED: '同意',
    REJECTED: '未同意',
    PENDING: '待同意'
  },
  tagMatchType: {
    ALL: '全匹配',
    ANY: '匹配任一'
  },
  activenessType: {
    HOT: '高活跃',
    ACTIVE: '活跃',
    WARM: '一般活跃',
    COLD: '不活跃',
    POTENTIAL: '潜在'
  },
  seniority: {
    INTERN: '实习',
    ENTRY_LEVEL: '入门',
    JUNIOR: '初级',
    MIDDLE_LEVEL: '中级',
    SENIOR: '高级',
    LEADER: '主管',
    PRINCIPAL: '负责人',
    MANAGER: '经理',
    DIRECTOR: '总监',
    SENIOR_DIRECTOR: '高级总监',
    VP: '副总裁',
    EVP: '执行副总裁',
    CHIEF_OFFICER: '首席官'
  },
  emailTemplate: {
    invitationSubject: '"{jobsName}" 职位新求职者-需要评估',
    invitationContent: '{braceLeft} Company Default Email Header {braceRight}\n' +
      '亲爱的{braceLeft} User Name {braceRight}：\n\n' +
      '你收到评估"{jobsName}"求职者的邀请。请点击下方链接开始评估并提交。期待收到你的回复！\n\n' +
      '{braceLeft} Candidate Rate List {braceRight}\n' +
      '{braceLeft} Company Default Email Footer {braceRight}',
    hmInterviewSubject: '关于"{cnJobsName}"一职的求职者面试邀约 Candidate Interview Invitation for "{jobsName}"',
    hmInterviewContent:
      'Please scroll down for English version.\n\n' +
      '亲爱的{braceLeft} Chinese User Name {braceRight}：\n\n' +
      '您收到一个关于"{cnJobsName}"一职的求职者面试邀请，面试的具体信息参见下方：\n\n' +
      '日期：        {braceLeft} Chinese Date {braceRight}\n' +
      '时间：        {braceLeft} Chinese Start Time {braceRight}至{braceLeft} Chinese End Time {braceRight}\n' +
      '{cnAddressContent}' +
      '下方是关于求职者的信息表以及点击链接可以打开面试评估表，请确保再面试结束后提交面试评估表。期待收到你的回复！\n\n' +
      '{braceLeft} Chinese Candidate Info Table {braceRight}\n\n' +
      '{braceLeft} Chinese Recruiter Name {braceRight}\n\n' +
      '{braceLeft} Chinese and English dividing line {braceRight}\n\n' +
      'Dear {braceLeft} English User Name {braceRight},\n\n' +
      'You have received an invitation for a candidate interview for the role of: {jobsName}. The interview details are outlined below: \n\n' +
      'Date:        {braceLeft} English Date {braceRight}\n' +
      'Time:        {braceLeft} English Start Time {braceRight} - {braceLeft} English End Time {braceRight}\n' +
      '{addressContent}' +
      'Please find attached further information about the candidate(s) listed below together with the interview rating form. Please make sure to complete and submit the interview rating form directly after the interview. I look forward to your response.\n\n' +
      '{braceLeft} English Candidate Info Table {braceRight}\n\n' +
      '{braceLeft} English Recruiter Name {braceRight}\n' +
      '请向上滚动查看中文版本。',
    candidateInterviewSubject: '关于您申请"{cnCompanyName}"的"{cnJobsName}"一职的面试邀约 Job Interview Invitation for "{jobsName}" at "{companyName}"',
    candidateInterviewContent:
      '{braceLeft} Company Default Email Header {braceRight}\n\n' +
      'Please scroll down for English version.\n\n' +
      '亲爱的{braceLeft} Chinese User Name {braceRight}：\n\n' +
      '恭喜您！您被邀请参加"{cnCompanyName}"的"{cnJobsName}"下一步面试流程！面试的具体信息参见下方：\n\n' +
      '日期：        {braceLeft} Chinese Date {braceRight}\n' +
      '时间：        {braceLeft} Chinese Start Time {braceRight}至{braceLeft} Chinese End Time {braceRight}\n' +
      '{cnAddressContent}{cnMicrositeContent}' +
      '{braceLeft} 这里可以填写您对参加面试的候选人的一些要求，例如着装等等 {braceRight}\n\n' +
      '{cnQrCodeTips}{qrCodeHtml}{cnWechatCodeContent}' +
      '{braceLeft} Chinese and English dividing line {braceRight}\n\n' +
      'Dear {braceLeft} English User Name {braceRight},\n\n' +
      'You have received an invitation for a job interview for the role of: "{jobsName}" at "{companyName}". The interview details are outlined below: \n\n' +
      'Date:        {braceLeft} English Date {braceRight}\n' +
      'Time:        {braceLeft} English Start Time {braceRight} - {braceLeft} English End Time {braceRight}\n' +
      '{addressContent}{micrositeContent}' +
      '{braceLeft} Insert custom instructions to the candidate about what to do upon arrival or what to bring to the interview here {braceRight}\n\n' +
      '{qrCodeTips}{qrCodeHtml}{wechatCodeContent}' +
      '请向上滚动查看中文版本。\n\n' +
      '{braceLeft} Company Default Email Footer {braceRight}',
    wechatCodeContent: '<div style="text-align: center;font-weight: bold;font-size: 20px;"><p>希望从微信收到面试提醒？扫描此二维码绑定吧！</p><img height="150" class="qrcode" src="{{ bindingWechatQrcode }}"></div>\n\n',
    micrositeContent: '<a style="font-size: 20px;" href="{{ micrositeUrl }}">点击此处了解更多相关信息</a>\n\n',
    addressContent: '地址：        {{ Chinese Location }}，{{ Chinese Detail Address }}\n\n',
    onlineAddress: {
      url: '线上面试链接：       <a href="{{ Online URl }}">单击此处以加入会议</a>\n',
      meetingId: '会议ID：             {{ Meeting ID }}\n',
      password: '密码：               {{ Meeting Password }}\n'
    }
  },
  PARENT_FIELD_NAME_LIST: {
    PersonalInfo: '个人信息',
    ApplicationInfo: '申请信息',
    FitnessInfo: '匹配度分数',
    AssessmentInfo: '价值观、优势和发展领域',
    InternExperienceInfo: '实习经验',
    ExperienceInfo: '工作经验',
    EducationInfo: '教育背景',
    AdditionalInfo: '附加信息',
    LanguageInfo: '语言',
    jobSurveyInfo: '申请人调查问卷',
    interviewRecordInfo: '面试记录',
    candidateConsentInfo: '候选人协议同意情况',
    hmRateInfo: '招聘经理评估',
    aiInterviewInfo: 'AI面试信息'
  },
  STATUS_GROUP: {
    APPLY: '申请',
    SCREEN: '筛选',
    INTERVIEW: '面试',
    OFFER: 'Offer',
    HIRED: '雇用'
  },
  READ_STATUS: {
    READ: '已读',
    UNREAD: '未读'
  },
  candidatePreferenceSurvey: {
    COMPLETED_NO_APPLICATIONS: '已完成未申请',
    COMPLETED_HAS_APPLICATIONS: '已完成已申请'
  },
  APPLICATION_STATUS: {
    FINISHED: '申请完成',
    UNFINISHED: '申请未完成'
  },
  agencyUploadStatus: {
    ACCEPTED: '接受',
    REJECTED: '拒绝',
    PENDING: '待定'
  },
  cvOwner: {
    hr: '招聘人员',
    agency: '猎头',
    disabledHr: '招聘人员（已禁用）',
    disabledAgency: '猎头（已禁用）'
  },
  resumeSDKTagKey: {
    INDUSTRY: '行业信息',
    POSITION: '职位名称',
    JOB_SKILL: '工作技能',
    SOFT_SKILL: '软素质技能',
    COLLEGE_LEVEL: '学校类别',
    ABROAD_EDU: '海外留学经历',
    COMPANY_LEVEL: '公司类型',
    JOB_STABILITY: '工作稳定性',
    RISKS: '风险点名称'
  },
  recommendationLoadTaskStatus: {
    failed: '失败',
    success: '成功',
    empty: '无更多候选人',
    pending: '生成中'
  },
  AI_COMPARISON_TASK_STATUS: {
    START: 'AJINGA 智能 AI 正在处理您的请求。您可以在此处等待结果，也可以随时关闭此弹出窗口，稍后在 AI 比较历史表中查看结果。',
    REVIEW: 'AJINGA 智能 AI 正在阅读对比标准…',
    READING: 'AJINGA 智能 AI 正在查阅候选人简历…',
    COMPARING: 'AJINGA 智能 AI 正在对候选人进行对比分析…',
    THINKING: 'AJINGA 智能 AI 正在思考…',
    WRITING: 'AJINGA 智能 AI 正在生成候选人对比报告…'
  },
  INTERVIEW_STATUS: {
    NOT_STARTED: '未开始',
    IN_PROGRESS: '进行中',
    COMPLETED: '已完成'
  },
  tip: {
    companyLevelTag: '此筛选功能使您能够专注于具有Top雇主经验的候选人，例如财富500强公司或其他行业领先的组织。',
    hardSkillTag: '此筛选功能使您能够根据候选人的硬技能（具体例如：可教授的能力，如编程、数据分析或会计）来集中关注，这些技能由AJINGA智能体从他们的简历中提取。',
    softSkillTag: '此筛选功能使您能够根据候选人的软技能（如沟通、团队合作或解决问题等个人特质）来集中关注，这些技能由AJINGA智能体从他们的简历中提取。',
    schoolTier: '此筛选功能使您能够根据AJINGA智能体从其简历中提取的信息，专注于那些曾在中国Top大学（如211或985院校）就读的候选人。',
    stabilityTag: '此筛选功能使您能够关注那些工作历史可能不太稳定的候选人，标记出那些在单一公司平均任职时间少于15个月的人。\n此筛选功能识别的潜在风险仅供参考。该筛选基于候选人简历中提供的信息，可能无法完全反映其完整背景或对职位的适合性。因此，在使用此筛选功能进行决策时，请谨慎行事。',
    riskTag: '此筛选功能使您能够关注那些背景中可能存在潜在风险的候选人，例如空档期（失业期间）或非传统教育背景，包括教育记录中的空白、从专科过渡到本科水平，或仅拥有职业院校级别的教育。\n此筛选功能识别的潜在风险仅供参考。该筛选基于候选人简历中提供的信息，可能无法完全反映其完整背景或对职位的适合性。因此，在使用此筛选功能进行决策时，请谨慎行事。',
    selectHiringManager: '输入你希望发送邀请的面试官的联系方式'
  },
  week: {
    mon: '周一',
    tue: '周二',
    wed: '周三',
    thu: '周四',
    fri: '周五',
    sat: '周六',
    sun: '周日'
  }
}
